import { request } from "../api/client";
import { savePostLoginRedirect, storeAuthSession } from "./auth-session";

export const signInWithGoogle = async (credential) => {
  const data = await request("/auth/google/sign-in", {
    method: "POST",
    body: JSON.stringify({ idToken: credential }),
  });

  return storeAuthSession({
    access_token: data.access_token,
    token_type: data.token_type,
    expires_in: data.expires_in,
    session_type: data.session_type,
    provider: "google",
  });
};

export const beginGoogleLoginWithReturn = (returnPath) => {
  savePostLoginRedirect(returnPath);
};
